export const sapFioriHcbParameters = {};
